import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { UserIsSubscribed } from '../../features/auth/authWrapper';
import { Field, reduxForm } from 'redux-form';
// import ReactGA from 'react-ga';

import LoadingScreen from './LoadingScreen';

// ReactGA.initialize('UA-128097930-1');
// ReactGA.pageview(window.location.pathname + window.location.search);

const AsyncLandingPage = Loadable({
  loader: () => import('../../features/landing/LandingPage'),
  loading: LoadingScreen
});

const AsyncNewLanding = Loadable({
  loader: () => import('../../features/landing/LandingLayout'),
  loading: LoadingScreen
});

const AsyncPrivacyPolicy = Loadable({
  loader: () => import('../../features/static/PrivacyPolicy'),
  loading: LoadingScreen
});

const AsyncTerms = Loadable({
  loader: () => import('../../features/static/TermsOfService'),
  loading: LoadingScreen
});

const AsyncCompliance2257 = Loadable({
  loader: () => import('../../features/static/2257'),
  loading: LoadingScreen
});

const AsyncRefunds = Loadable({
  loader: () => import('../../features/static/RefundPolicy'),
  loading: LoadingScreen
});

const AsyncLogin = Loadable({
  loader: () => import('../../features/auth/Login/Login'),
  loading: LoadingScreen
});

const AsyncForgotPassword = Loadable({
  loader: () => import('../../features/auth/Login/ForgotPassword'),
  loading: LoadingScreen
});

const AsyncSignup = Loadable({
  loader: () => import('../../features/auth/Signup/Signup'),
  loading: LoadingScreen
});

// const AsyncSignupDisabled = Loadable({
//   loader: () => import('../../features/auth/Signup/SignupDisabled'),
//   loading: LoadingScreen
// });

// const AsyncPayment = Loadable({
//   loader: () => import('../../features/auth/Signup/Payment'),
//   loading: LoadingScreen
// });

const AsyncTempPayment = Loadable({
  loader: () => import('../../features/auth/Signup/TempPayment'),
  loading: LoadingScreen
});

// const AsyncPaymentCCBill = Loadable({
//   loader: () => import('../../features/auth/Signup/PaymentCCBill'),
//   loading: LoadingScreen
// });

const AsyncBTSDashboard = Loadable({
  loader: () => import('../../features/bts/BTSDashboard/BTSDashboard'),
  loading: LoadingScreen
});

const AsyncBTSDetail = Loadable({
  loader: () => import('../../features/bts/BTSDetail/BTSDetail'),
  loading: LoadingScreen
});

const AsyncDashboard = Loadable({
  loader: () =>
    import('../../features/episode/EpisodeDashboard/EpisodeDashboard'),
  loading: LoadingScreen
});

const AsyncEpisodeDetail = Loadable({
  loader: () => import('../../features/episode/EpisodeDetail/EpisodeDetail'),
  loading: LoadingScreen
});

const AsyncClassicDashboard = Loadable({
  loader: () =>
    import('../../features/classic/ClassicDashboard/ClassicDashboard'),
  loading: LoadingScreen
});

const AsyncClassicDetail = Loadable({
  loader: () => import('../../features/classic/ClassicDetail/ClassicDetail'),
  loading: LoadingScreen
});

const AsyncUserSettings = Loadable({
  loader: () => import('../../features/user/UserSettings/Settings'),
  loading: LoadingScreen
});

// const AsyncRaffle = Loadable({
//   loader: () => import('../../features/raffle/Raffle/Raffle'),
//   loading: LoadingScreen
// });

// const AsyncVideoUpload = Loadable({
//   loader: () => import('../../features/admin/VideoUpload/VideoUpload'),
//   loading: LoadingScreen
// });

class App extends Component {
  render() {
    return (
      <Fragment>
        <Switch>
          {/* <Route exact path="/" component={AsyncLandingPage} /> */}
          <Route exact path="/" component={AsyncNewLanding} />
          <Route path="/privacy" component={AsyncPrivacyPolicy} />
          <Route path="/terms" component={AsyncTerms} />
          <Route path="/2257" component={AsyncCompliance2257} />
          <Route path="/refunds" component={AsyncRefunds} />
          {/* <Route path="/login" component={AsyncLogin} />
          <Route path="/forgot-password" component={AsyncForgotPassword} />
          <Route exact path="/signup" component={AsyncSignup} /> */}
          {/* <Route exact path="/signup" component={AsyncSignupDisabled} /> */}
          {/* <Route path="/signup/payment" component={AsyncPayment} /> */}
          {/* <Route path="/signup/payment" component={AsyncTempPayment} /> */}
          <Route
            path="/dashboard"
            component={UserIsSubscribed(AsyncDashboard)}
            key="dashboard"
          />
          <Route exact path="/bts" component={AsyncBTSDashboard} />
          <Route exact path="/classics" component={AsyncClassicDashboard} />
          <Route path="/classics/:id" component={AsyncClassicDetail} />
          <Route path="/episode/:id" component={AsyncEpisodeDetail} />
          <Route path="/bts/:id" component={AsyncBTSDetail} />
          <Route path="/settings" component={AsyncUserSettings} />
          {/* <Route path="/admin/video-upload" component={AsyncVideoUpload} /> */}
          {/* <Route path="/user/raffle" component={AsyncRaffle} /> */}
          <Route component={AsyncNewLanding} />
        </Switch>
      </Fragment>
    );
  }
}

export default App;
